import React, { useEffect, useState } from "react";
import { Table, Button, Alert } from "react-bootstrap";
import PaginationButtons from "../../../reuseable-components/PaginationButtons";
import axios from "axios";
import swal from "sweetalert";
import getServerURL from "../../../functions/getServerURL";
import { handleErrorFetchingData } from "../../../functions/errorHandling";

export default function DeactivatedTrainings() {
  const [deactivatedTrainings, setDeactivatedTrainings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const entriesPerPage = 10;

  // Fetch deactivated trainings
  const fetchDeactivatedTrainings = (page = currentPage) => {
    setLoading(true);
    page = page || 1;
    setCurrentPage(page);
    axios
      .get(`${getServerURL()}trainings?is_active=false`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: {
          limit: entriesPerPage,
          offset: entriesPerPage * (page - 1),
        },
      })
      .then((response) => {
        setDeactivatedTrainings(response.data.results || []); // Extract `results` field
        setNumberOfPages(Math.ceil(response.data.count / entriesPerPage)); // Calculate total pages
      })
      .catch((error) => {
        setErrorMessage("Failed to fetch deactivated trainings.");
        handleErrorFetchingData(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Activate a training
  const handleActivateTraining = (training) => {
    swal({
      text: `Activating ${training.name}... Please stand by.`,
      icon: require("../../../static/images/spinner.gif"),
      button: false,
    });
    axios
      .patch(training.url, { is_active: true }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(() => {
        swal({
          title: "Activated",
          text: `${training.name} has been successfully activated.`,
          icon: "success",
          button: "OK",
        }).then(() => {
          fetchDeactivatedTrainings(); // Refresh the list of deactivated trainings
        });
      })
      .catch((error) => {
        const message = `There was an error activating the training: ${training.name}`;
        handleErrorFetchingData(error, message);
      });
  };

  useEffect(() => {
    fetchDeactivatedTrainings();
  }, []);

  return (
    <div>
      <h3>Deactivated Trainings</h3>
      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
      {numberOfPages > 1 && (
        <center>
          <PaginationButtons
            onClick={fetchDeactivatedTrainings}
            numberOfPages={numberOfPages}
            currentPage={currentPage}
            buttonsPerPage={5}
            disabled={loading}
          />
        </center>
      )}
      {loading ? (
        <p>Loading...</p>
      ) : deactivatedTrainings.length === 0 ? (
        <p>No deactivated trainings found.</p>
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {deactivatedTrainings.map((training) => (
              <tr key={training.id}>
                <td>{training.name}</td>
                <td>
                  <Button
                    variant="success"
                    onClick={() => handleActivateTraining(training)}
                  >
                    Activate
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/DeactivatedTrainings.js